import http from '@/services/http';

export interface ApiClient {
  id: string;
  name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ApiClientListResponse {
  items: ApiClient[];
  total: number;
  limit: number;
  offset: number;
}

export async function listClients(params?: { search?: string; active?: boolean; limit?: number; offset?: number }) {
  const response = await http.get<ApiClientListResponse>('/api/clients', {
    params: {
      search: params?.search || undefined,
      active: params?.active,
      limit: params?.limit ?? 200,
      offset: params?.offset ?? 0,
    },
  });

  return response.data;
}

export async function getClientById(id: string) {
  const response = await http.get<ApiClient>(`/api/clients/${id}`);
  return response.data;
}
